import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X, Download } from "lucide-react";

interface Props {
  src: string;
  alt?: string;
  fileName?: string | null;
  onClose: () => void;
}

export function ImageLightbox({ src, alt, fileName, onClose }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  return createPortal(
    <div
      className="fixed inset-0 z-[2147483647] flex items-center justify-center cz-fade-in"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={alt ?? "Imagem"}
    >
      <div className="absolute inset-0 bg-black/85" />

      <button
        type="button"
        onClick={onClose}
        aria-label="Fechar"
        className="absolute top-4 right-4 z-10 h-10 w-10 rounded-full bg-black/50 text-white hover:bg-black/70 flex items-center justify-center"
      >
        <X className="h-5 w-5" />
      </button>

      <a
        href={src}
        download={fileName ?? undefined}
        target="_blank"
        rel="noreferrer"
        onClick={(e) => e.stopPropagation()}
        aria-label="Baixar"
        className="absolute top-4 right-16 z-10 h-10 w-10 rounded-full bg-black/50 text-white hover:bg-black/70 flex items-center justify-center"
      >
        <Download className="h-5 w-5" />
      </a>

      <img
        src={src}
        alt={alt ?? "Imagem"}
        className="relative z-10 max-w-[92vw] max-h-[88vh] object-contain rounded-lg"
        onClick={(e) => e.stopPropagation()}
      />
    </div>,
    document.body,
  );
}
